export default __webpack_public_path__ + "moin-app-illus-home.5d7eba40f274d1a9e2fe098469b8384c.png";